import lottie from 'lottie-web';
import * as locomotive from './locomotive';

export default (node) => {
    const json = node.dataset.json;

    if (!json) return;

    var animation = lottie.loadAnimation({
        container: node,
        renderer: "svg",
        autoplay: true,
        path: json,
    });

    animation.addEventListener('DOMLoaded', function(e) { 
        locomotive.update();
    });
};